// 会員情報編集ページのスタイル定義

export const COLORS = {
  primary: '#09529f',
  primaryDark: '#002348',
  success: '#28a745',
  successBg: '#d4edda',
  danger: '#dc3545',
  dangerBg: '#f8d7da',
  warning: '#ffc107',
  warningBg: '#fff3cd',
  warningText: '#856404',
  white: '#fff',
  lightGray: '#f8f9fa',
  borderGray: '#dee2e6',
  textGray: '#666',
  appBackground: '#F0F8FF'
};

// ブレークポイント
export const BREAKPOINTS = {
  mobile: '768px'
};

export const styles = {
  // ページ全体のコンテナ
  container: {
    minHeight: '100vh',
    backgroundColor: COLORS.appBackground,
    padding: '20px'
  },
  
  // メインコンテンツ
  content: {
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: COLORS.white,
    borderRadius: '8px',
    padding: '40px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    border: `2px solid ${COLORS.primary}`
  },
  
  // ヘッダーエリア
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '30px',
    borderBottom: `3px solid ${COLORS.primary}`,
    paddingBottom: '15px'
  },
  
  // ページタイトル
  title: {
    fontSize: '28px',
    fontWeight: 'bold',
    color: COLORS.primary,
    margin: 0
  },

  // 戻るボタン
  backButton: {
    backgroundColor: '#09529f',
    color: COLORS.white,
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '14px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginRight: '10px',
    whiteSpace: 'nowrap'
  },
  
  // CSRFステータス表示
  csrfStatus: {
    padding: '12px 16px',
    borderRadius: '4px',
    marginBottom: '20px',
    fontSize: '14px',
    fontWeight: 'bold'
  },
  
  csrfStatusLoading: {
    backgroundColor: COLORS.warningBg,
    border: `1px solid ${COLORS.warning}`,
    color: COLORS.warningText
  },
  
  csrfStatusError: {
    backgroundColor: COLORS.dangerBg,
    border: `1px solid ${COLORS.danger}`,
    color: COLORS.danger
  },
  
  // タブコンテナ
  tabContainer: {
    display: 'flex',
    borderBottom: `2px solid ${COLORS.borderGray}`,
    marginBottom: '30px',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch'
  },
  
  // タブボタン
  tab: {
    padding: '15px 25px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderBottom: '3px solid transparent',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'all 0.2s ease',
    color: COLORS.textGray,
    whiteSpace: 'nowrap',
    minWidth: 'fit-content'
  },
  
  // アクティブタブ
  activeTab: {
    borderBottomColor: COLORS.primary,
    color: COLORS.primary
  },
  
  // フォームセクション
  formSection: {
    minHeight: '400px'
  },
  
  // テーブルスタイル
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '30px',
    backgroundColor: COLORS.white,
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
  },
  
  th: {
    backgroundColor: COLORS.lightGray,
    padding: '15px 20px',
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#333',
    border: `1px solid ${COLORS.borderGray}`,
    width: '200px',
    verticalAlign: 'top'
  },
  
  td: {
    padding: '15px 20px',
    border: `1px solid ${COLORS.borderGray}`,
    verticalAlign: 'top'
  },
  
  // 入力フィールド
  input: {
    width: '100%',
    padding: '8px 12px',
    border: `1px solid ${COLORS.borderGray}`,
    borderRadius: '4px',
    fontSize: '14px',
    transition: 'border-color 0.2s ease',
    boxSizing: 'border-box'
  },
  
  inputError: {
    borderColor: COLORS.danger,
    borderWidth: '2px'
  },
  
  // セレクトボックス
  select: {
    width: '100%',
    padding: '8px 12px',
    border: `1px solid ${COLORS.borderGray}`,
    borderRadius: '4px',
    fontSize: '14px',
    backgroundColor: COLORS.white,
    boxSizing: 'border-box'
  },
  
  // 必須マーク
  required: {
    color: COLORS.danger,
    marginLeft: '3px',
    fontWeight: 'bold'
  },
  
  // エラーメッセージ
  error: {
    color: COLORS.danger,
    fontSize: '12px',
    marginTop: '4px',
    fontWeight: 'bold'
  },
  
  // ボタンコンテナ
  buttonContainer: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    borderTop: `2px solid ${COLORS.borderGray}`
  },
  
  // 基本ボタンスタイル
  button: {
    padding: '12px 30px',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s ease'
  },
  
  // プライマリボタン
  primaryButton: {
    backgroundColor: COLORS.primary,
    color: COLORS.white
  },
  
  // セカンダリボタン
  secondaryButton: {
    backgroundColor: COLORS.textGray,
    color: COLORS.white
  },
  
  // ローディングメッセージ
  loadingMessage: {
    textAlign: 'center',
    fontSize: '18px',
    color: COLORS.textGray,
    padding: '40px'
  }
};

// モバイル用スタイル
export const mobileStyles = `
  @media (max-width: ${BREAKPOINTS.mobile}) {
    .member-edit-container {
      padding: 10px !important;
    }
    
    .member-edit-content {
      padding: 15px !important;
      border-radius: 4px !important;
    }
    
    .member-edit-header {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 15px !important;
      margin-bottom: 20px !important;
    }
    
    .member-edit-title {
      font-size: 20px !important;
    }
    
    .member-edit-back-button {
      width: 100% !important;
      margin-right: 0 !important;
      text-align: center !important;
    }
    
    .member-edit-tab-container {
      gap: 0 !important;
      margin-bottom: 20px !important;
    }
    
    .member-edit-tab {
      padding: 12px 10px !important;
      font-size: 13px !important;
      flex: 1 !important;
    }
    
    /* テーブルをカード形式に変換 */
    .member-edit-table {
      display: block !important;
      box-shadow: none !important;
    }
    
    .member-edit-table tbody {
      display: block !important;
    }
    
    .member-edit-table-row {
      display: block !important;
      margin-bottom: 15px !important;
      border: 1px solid ${COLORS.borderGray} !important;
      border-radius: 8px !important;
      padding: 12px !important;
      background-color: #fff !important;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    }
    
    .member-edit-table-th,
    .member-edit-table-td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
      border: none !important;
      text-align: left !important;
      background-color: transparent !important;
    }
    
    .member-edit-table-th {
      padding-bottom: 8px !important;
      font-size: 13px !important;
      font-weight: bold !important;
      color: #333 !important;
    }
    
    .member-edit-table-td {
      padding-top: 0 !important;
    }
    
    .member-edit-table-td input,
    .member-edit-table-td select {
      font-size: 16px !important;
      padding: 12px !important;
    }
    
    .member-edit-button-container {
      flex-direction: column-reverse !important;
      gap: 10px !important;
      margin-top: 30px !important;
    }
    
    .member-edit-button {
      width: 100% !important;
      padding: 14px 20px !important;
      font-size: 16px !important;
    }
  }
`;

// スタイルシートに追加
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = mobileStyles;
  document.head.appendChild(styleElement);
}